import React from 'react';
import {
    Button,
    Card,
    CardContent
} from "@mui/material";
import { Link, useParams, useNavigate } from 'react-router-dom';
import { X, MessageSquare } from "lucide-react";
import './MobileMenu.css';

const MobileMenu = ({
    isOpen,
    closeMenu,
    activeTab,
    handleMenuClick,
    handleLaunchChat,
    handleLogin,
    decisionSimilaireData,
    decisionId,
}) => {
    const menuItems = [
        { name: "Synthèse", key: "synthese" },
        { name: "Faits et procédures", key: "faits_procedures" },
        { name: "Motifs", key: "motifs" },
        { name: "Références légales", key: "references_legales" },
        { name: "Résumé", key: "resume" },
        { name: "Décision complète", key: "decision_complet" },
    ];

    const navigate = useNavigate();




    if (!isOpen) return null;

    return (
        <div className="mobile-menu-overlay">
            <div className="mobile-menu">
                <div className="mobile-menu-header">
                    <h2>Menu</h2>
                    <button
                        className="mobile-menu-close"
                        onClick={closeMenu}
                        aria-label="Fermer le menu"
                    >
                        <X size={20} />
                    </button>
                </div>

                <div className="mobile-menu-content">
                    <section className="mobile-menu-section">
                        <h3 className="mobile-menu-section-title">Navigation</h3>
                        <ul className="mobile-menu-list">
                            {menuItems.map((item) => (
                                <li key={item.key}>
                                    <button
                                        className={`mobile-menu-item ${activeTab === item.key ? "active" : ""}`}
                                        onClick={() => handleMenuClick(item.key)}
                                    >
                                        {item.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </section>

                    <section className="mobile-menu-section">
                        <h3 className="mobile-menu-section-title">Décisions similaires</h3>
                        <ul className="mobile-menu-list">
                            {decisionSimilaireData && decisionSimilaireData.length > 0 ? (
                                <>
                                    <ul className="history-list">
                                        {decisionSimilaireData.slice(0, 2).map((decision, index) => (
                                            <li key={decision.id || index}>
                                                <Link to={`/decision/${decision.id}`}>
                                                    {decision.type_decision || "Décision"}, {decision.date_emission || "N/A"}, {decision.reference || "N/A"}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                    {decisionSimilaireData.length > 2 && (
                                        <div className="mt-3 text-center">
                                            <Button
                                                onClick={() => navigate(`/allresult?decision-id=${decisionId}`)}
                                                className=""
                                            >
                                                <span>Voir toutes les décisions</span>
                                            </Button>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <p className="no-data">Aucune décision similaire disponible</p>
                            )}
                        </ul>

                    </section>

                    <section className="mobile-menu-section">
                        <h3 className="mobile-menu-section-title">Décisions liées</h3>
                        <ul className="mobile-menu-list">
                            <li><button className="mobile-menu-item">Cour d'appel, 10 jan 2023, 425600</button></li>
                            <li><button className="mobile-menu-item">Tribunal de commerce, 05 avril 2022, 398714</button></li>
                            <li><button className="mobile-menu-item">Cour de cassation, 18 mai 2021, 342189</button></li>
                        </ul>
                    </section>

                    <div className="mobile-menu-buttons">
                        <button className="mobile-chat-button" onClick={handleLaunchChat}>
                            <MessageSquare size={18} />
                            <span>Lancer la discussion avec l'assistant IA</span>
                        </button>

                        <button className="mobile-login-button" onClick={handleLogin}>
                            Se connecter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileMenu;